import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../Context/jsonEditorContext";
import ProfileForm from "../../hooks/editor/profileForm";
import ResumeSubUseForm from "../../hooks/editor/resumeSubUseForm";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import { useTranslation } from "react-i18next";
import SectionToolbar from "../../Components/GlobalSectionToolbar/SectionToolbar";
import ProfileImageModal from "../../Components/Modals/ProfileImageModal";
import AddAdditionalFieldModal from "../../Components/Modals/AddAdditionalFieldModal/AddAdditionalFieldModal";
import ErrorMessage from "../../Components/Analyzer/ErrorPopup/ErrorPopup";
import { sectionPaddings } from "../../TemplateConfig";
import tinycolor from "tinycolor2";

function SectionContainer(props) {
  const { styles, layout } = props;
  const [t, i18n] = useTranslation("common");
  const [profileJob, setProfileJob] = useState("");
  const [showAddField, setShowAddField] = useState(false);
  const sectionRef = useRef(null);
  const [sectionPading, setSectionPadding] = useState("unset");

  const [focusClassName, setFocusClassName] = useState("sectionFocusStyle");
  const [bgColor, setBgColor] = useState("#ffffff");

  const { setSideBasic, setSuggestionSection, setJobTile, setSuggestionIndex } =
    useContext(ResumePopupContext);
  //Redux state
  const settings = useSelector((state) => state.editorData.editorSettings);
  const profileData = useSelector((state) => state.editorData.profile);

  useEffect(() => {
    if (props && props.SectionMargin) {
      const secMargin = parseInt(props && props.SectionMargin);
      setSectionPadding(sectionPaddings[secMargin - 1]);
    }
  }, [props && props.SectionMargin]);

  //Local State

  //UseForm
  const {
    fileUpload,
    resetImage,
    modalShow,
    setModalShow,
    profileImage,
    fileUploadError,
    setFileUploadError,
    disableSave,
    setDisableSave,
  } = ProfileForm(
    props.sectionId,
    props.resumeAllFields,
    props.setResumeFields,
    props.resumeUpdate
  );

  const {
    // addResumeField,
    sectionTitleUpdate,
    sectionTitleRemove,
    handleCustomDelete,
    showHideElements,
    showHideBackground,
  } = ResumeSubUseForm(props.sectionId);

  const onresumeHide = () => {
    setModalShow(false);
    setFileUploadError("");
  };

  const mainSectionClick = (e, title) => {
    props.changeFocusStyle(props.sectionId, false, "section");
  };

  const innerSectionClick = (e, index) => {
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  const changeSettings = (key, index) => {
    props.showHideElements(key, index, props.sectionId);
  };
  const handleBackground = () => {
    props.showHideBackground();
  };
  const [summaryQuillEditor, setSummaryQuillEditor] = useState(true);

  const changeSummaryQuillEditor = (status) => {
    setSummaryQuillEditor(status);
  };

  const editIconClick = () => {
    setJobTile(
      profileData &&
        profileData.data &&
        profileData.data[0] &&
        profileData.data[0].jobTitle
    );
    setSideBasic(true);
    setSuggestionSection(props.sectionId);
    setSuggestionIndex(0);
  };

  useEffect(() => {
    setProfileJob(
      profileData &&
        profileData.data &&
        profileData.data[0] &&
        profileData.data[0].jobTitle
    );
  }, [profileData]);

  const handleAddAdditionalField = () => {
    setShowAddField(!showAddField);
  };
  var _docHeight =
    document.height !== undefined
      ? document.height
      : document.body.offsetHeight;
  var _docWidth =
    document.width !== undefined ? document.width : document.body.offsetWidth;

  const addResumeField1 = (ref, value, section) => {
    props.addResumeField(ref, value, section);
    if (props.sectionId != "profile") {
      setTimeout(() => {
        props.changeFocusStyle(
          props.sectionId,
          value.length.toString(),
          "item"
        );
        const element = document.getElementsByClassName("sectionFocusStyle");

        if (element && element[0]) {
          element[0].scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }, 350);
    }
  };

  useEffect(() => {
    // if (
    //   styles &&
    //   styles.selectedBgColor &&
    //   styles.selectedBgColor.is_different_color &&
    //   layout == "rsbar"
    // ) {
    //   setFocusClassName("sectionDifferentFocusStyle");
    // }
    const { bgColor } = { ...styles };
    if (bgColor && bgColor.bgFill === "right" && props.pos == "rsbar") {
      setBgColor(
        tinycolor(bgColor && bgColor.bgColor).isLight() ? "#fff" : "#ffffff1f"
      );
    } else if (bgColor && bgColor.bgFill === "left" && props.pos == "lsbar") {
      setBgColor(
        tinycolor(bgColor && bgColor.bgColor).isLight() ? "#fff" : "#ffffff1f"
      );
    } else if (bgColor && bgColor.bgFill === "top" && props.pos == "profile") {
      setBgColor(
        tinycolor(bgColor && bgColor.bgColor).isLight() ? "#fff" : "#ffffff1f"
      );
    } else {
      setBgColor("#ffffff");
    }
  }, [styles, props]);

  const { improveTexts, setImproveTexts } = useContext(jsonEditorContext);
  const [isHovered, setIsHovered] = useState(false);
  const alteredSectionID = improveTexts[
    `${props.sectionId.charAt(0).toUpperCase()}${props.sectionId.slice(1)}`
  ]
    ? props.sectionId.charAt(0).toUpperCase() + props.sectionId.slice(1)
    : props.sectionId;

  useEffect(() => {
    if (props && props.SectionMargin) {
      const secMargin = parseInt(props && props.SectionMargin);
      setSectionPadding(sectionPaddings[secMargin - 1]);
    }
  }, [props && props.SectionMargin]);

  return (
    <>
      {modalShow && (
        <ProfileImageModal
          show={modalShow}
          fileUploadError={fileUploadError}
          onHide={onresumeHide}
          upload={(e) => {
            fileUpload(e, "profile");
          }}
          disableSave={disableSave}
          setDisableSave={setDisableSave}
        />
      )}
      {props && props.sectionId == "profile" && (
        <AddAdditionalFieldModal
          show={showAddField}
          sectionId={props.sectionId}
          handleAddAdditionalField={handleAddAdditionalField}
          addResumeField={addResumeField1}
          resumeFields={props.resumeFields}
        />
      )}

      <section
        ref={sectionRef}
        style={
          props.newSectionFocus === props.sectionId &&
          !props.previewModal &&
          props.currentStateFocus !== "item"
            ? { backgroundColor: bgColor, paddingBottom: sectionPading }
            : { paddingBottom: sectionPading }
        }
        className={`${
          props.sectionId
        }-section resume-section  resume-section  ${
          props.newSectionFocus == props.sectionId &&
          !props.previewModal &&
          props.currentStateFocus != "item"
            ? focusClassName
            : ""
        } ${props.extraProfileClassName ? props.extraProfileClassName : ""}`}
        id={
          props && props.isHeader && props.isHeader
            ? "top-extra"
            : `${props.sectionId}-${props.pageIndex}-section`
        }
        onClick={(e) => mainSectionClick(e, "title")}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {summaryQuillEditor &&
          props.newSectionFocus == props.sectionId &&
          props.currentStateFocus &&
          props.currentStateFocus != "item" &&
          props.visualEditorFocus && (
            <SectionToolbar
              index={props.index}
              indexString={props.index.toString()}
              row={props.row}
              editPopupShow={editIconClick}
              addAdditionalField={addResumeField1}
              deletePopupShow={props.deletePopupShow}
              //   sectionMoveUp={sectionMoveUp}
              //   sectionMoveDown={sectionMoveDown}
              sectionMoveUp={props.sectionMoveUp}
              sectionMoveDown={props.sectionMoveDown}
              layout={props.layout}
              sectionId={props.sectionId}
              changeSettings={changeSettings}
              resumeFields={props.resumeFields}
              background={props.styles.background}
              handleBackground={handleBackground}
              handleAddAdditionalField={handleAddAdditionalField}
              handleSliderChange={props.handleSliderChange}
              handleProfileImageChange={props.handleProfileImageChange}
              settings={settings}
              reArrangeStatus={props.reArrangeStatus}
              setReArrangeStatus={props.setReArrangeStatus}
              changeIconSettings={props.changeIconSettings}
            />
          )}
        {React.Children.map(props.children, (child) => {
          return React.cloneElement(
            child,
            {
              resumeHandler: props.resumeHandler,
              resumeTitleHandler: props.resumeTitleHandler,
              resumeUpdate: props.resumeUpdate,
              resumeFields: props.resumeFields,
              sectionTitleUpdate: props.sectionTitleUpdate,
              handleEditorChange: props.handleEditorChange,
              changeSettings: changeSettings,
              dateHandler: props.dateHandler,
              languageHandler: props.languageHandler,
              showHideElements: props.showHideElements,
              sectionItemMoveUp: props.sectionItemMoveUp,
              sectionItemMoveDown: props.sectionItemMoveDown,
              handleItemDelete: props.handleItemDelete,
              contentAdder: props.contentAdder,
              profileJob: profileJob,
              setModalShow: setModalShow,
              addAdditionalField: addResumeField1,
              styles: props.styles,
              sectionId: props.sectionId,
              layout: props.layout,
              handleSliderChange: props.handleSliderChange,
              handleProfileImageChange: props.handleProfileImageChange,
              changeSummaryQuillEditor: changeSummaryQuillEditor,
              skillsLevelHandler: props.skillsLevelHandler,
              handleBorderChange: props.handleBorderChange,
              SectionMargin: props.SectionMargin,

              ...props,
            },
            null
          );
        })}
        {/* {improveTexts &&
          improveTexts[alteredSectionID] &&
          improveTexts[alteredSectionID].errors &&
          improveTexts[alteredSectionID].errors.length > 0 &&
          isHovered && (
            <>
              <ErrorMessage
                errors={
                  improveTexts &&
                  improveTexts[alteredSectionID] &&
                  improveTexts[alteredSectionID].errors &&
                  improveTexts[alteredSectionID].errors
                }
              />
            </>
          )} */}
      </section>

      {settings &&
        settings.sectionUnderline &&
        (props.sectionId == "profile" ? (
          <>
            {!settings.isHideProfileUnderline && (
              <div>
                <hr
                  style={{
                    borderTop: `2px solid ${props.styles.secondaryColor}`,
                    position: "relative",
                    margin: "0px",
                    paddingBottom: "30px",
                  }}
                />
              </div>
            )}
          </>
        ) : (
          <div>
            <hr
              style={{
                borderTop: `2px solid ${props.styles.secondaryColor}`,
                position: "relative",
                margin: "0px",
                paddingBottom: "30px",
              }}
            />
          </div>
        ))}
    </>
  );
}

export default SectionContainer;
